var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12C2.75 6.88942 6.88942 2.75 12 2.75C17.1106 2.75 21.25 6.88941 21.25 12C21.25 17.1106 17.1106 21.25 12 21.25C11.5858 21.25 11.25 21.5858 11.25 22C11.25 22.4142 11.5858 22.75 12 22.75C17.939 22.75 22.75 17.939 22.75 12C22.75 6.06099 17.939 1.25 12 1.25C6.06099 1.25 1.25 6.06099 1.25 12C1.25 13.3045 1.45947 14.4843 1.77737 15.5481C1.85896 15.8211 2.0882 16.0243 2.36902 16.0725C2.64985 16.1207 2.93374 16.0057 3.10174 15.7755L5.93911 11.8886C6.18333 11.554 6.11009 11.0848 5.77553 10.8406C5.44097 10.5964 4.97178 10.6696 4.72756 11.0042L2.86481 13.556C2.79126 13.0602 2.75 12.5421 2.75 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V11.25H8C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H11.25V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V12.75H16C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25H12.75V8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadMedical);
export default __webpack_public_path__ + "static/media/reload-medical.85864238f02c1dc08b855e1aa70218a6.svg";
export { ForwardRef as ReactComponent };